import { css } from '@emotion/react';
import { N40A } from '@atlaskit/theme/colors';
import { commonTextStyles } from '../../styles/text';

/**
 * @see packages/editor/editor-plugin-ai/src/ui/screens/Preview/styles.ts
 */
export const previewContainer = css`
  border-top: 1px solid ${`var(--ds-border, ${N40A})`};
  border-bottom: 1px solid ${`var(--ds-border, ${N40A})`};
`;
export const layoutStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
`;
export const logoStyles = css`
  margin-right: 5px;
  display: flex;
  align-items: center;
`;
const titleLayoutStyles = css`
  flex: 1;
`;
export const titleStyles = [titleLayoutStyles, commonTextStyles];